import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {ModalController, PopoverController} from "@ionic/angular";
import {Language} from '../../../../types/interfaces';
import {TranslocoService} from "@jsverse/transloco";
import {MobileMenuComponent} from "../mobile-menu/mobile-menu.component";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {TelegramComponent} from "../../modals/chose-group/telegram/telegram.component";
import {EnglishLevelsComponent} from "../../modals/english-levels/english-levels.component";
import {AGREEMENT_LINK, FAQ_LINK, LANGUAGES, PAYMENT_LINK} from "../../../constants";
import {LocaleService} from "../../../../services/mygreencountry/locale.service";


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {

    protected readonly PAYMENT_LINK = PAYMENT_LINK;
    protected readonly AGREEMENT_LINK = AGREEMENT_LINK;
    protected readonly FAQ_LINK = FAQ_LINK;

    isPopMenuToggled: boolean = false;

    constructor(
        private router: Router,
        public popoverController: PopoverController,
        public myGcService: MyGreenCountry,
        private authService: AuthService,
        private modalCtrl: ModalController
    ) {
    }

    ngOnInit() {
    }


    async showMobileMenu(e: Event) {
        this.isPopMenuToggled = !this.isPopMenuToggled;
        const popover = await this.popoverController.create({
            component: MobileMenuComponent,
            showBackdrop: false,
            event: e,
            arrow: false,
            componentProps: {
                showStudentActions: true,
                onClick: () => {
                    popover.dismiss();
                },
            },
            cssClass: 'menu-popover',
            mode: "ios",

        });

        await popover.present();

        popover.onDidDismiss().then(() => {
            this.isPopMenuToggled = !this.isPopMenuToggled;
        });
    }


    async openEnglishLevelModal() {

        const modal = await this.modalCtrl.create({
            component: EnglishLevelsComponent,
            cssClass: 'auto-height',
            componentProps: {}
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    openUrl(url: string) {
        this.myGcService.openUrl(url)
    }
}
